import styled, { keyframes } from 'styled-components'

const bounce = keyframes`
  50% {
    transform: translateY(-10px);
  }
`

const shadowBounce = keyframes`
  50% {
    width: 40px;
  }
`

export const Container = styled.div`
  margin-top: 2rem;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  > svg {
    margin-bottom: .5rem;
    animation: ${bounce} 2s infinite cubic-bezier(0.39, 0.58, 0.57, 1);
  }
`

export const BrainShadow = styled.div`
  width: 62px;
  height: 10px;
  background: #F2EEED;
  border-radius: 99%;
  animation: ${shadowBounce} 2s infinite cubic-bezier(0.39, 0.58, 0.57, 1);
  margin-bottom: 2rem;
`